const itens = [
  'Tchau até mais',
  'Até a próxima',
  'Tchau',
  'Até logo',
  'Até mais'
]

export default () => {
  return itens[Math.floor(Math.random() * itens.length)] + '.'
}
